import type { Account, RawAccount } from './types';

/**
 * Canonical slug for the Builder plan. Mirrors `BuilderPlanSlug` in
 * customerio/services. Use `isBuilderPlan` rather than comparing the string
 * directly so there's a single source of truth.
 */
export const BUILDER_PLAN_SLUG = 'builder';

/** Slug for the Flex plan. Mirrors `FlexPlanSlug` in customerio/services. */
export const FLEX_PLAN_SLUG = 'flex_2026';

/**
 * Slug for the 2018 Basic plan, a legacy Stripe plan. It bills the subscription in advance and tiered
 * usage in arrears, so no single rate states its overage.
 */
export const BASIC_2018_PLAN_SLUG = '201804_pricing_basic';

export function isBuilderPlan(
  // Partial: a malformed or stale payload can arrive without the slug, and the
  // comparison below is what makes that read as "not Builder".
  account: Partial<Pick<Account, 'plan_slug'>> | Partial<Pick<RawAccount, 'plan_slug'>> | null | undefined,
) {
  return account?.plan_slug === BUILDER_PLAN_SLUG;
}

export function isFlexPlan(
  // Partial, as in `isBuilderPlan`. A payload with no slug is not Flex.
  account: Partial<Pick<Account, 'plan_slug'>> | Partial<Pick<RawAccount, 'plan_slug'>> | null | undefined,
) {
  return account?.plan_slug === FLEX_PLAN_SLUG;
}
